import React from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import SectionCard from "./SectionCard";

import { formatNumber } from "../utils/dashboardUtils";

export default function DistributionPieCard({
  loading,
  title,
  subtitle,
  icon,
  data = [],
  emptyLabel = "Aucune donnée disponible.",
}) {
  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);

  return (
    <SectionCard
      icon={icon}
      title={title}
      subtitle={subtitle}
      action={
        <span className="rounded-2xl bg-slate-100 px-3 py-2 text-sm font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-200">
          {formatNumber(total)} total
        </span>
      }
    >
      {loading ? (
        <div className="h-[340px] animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-800" />
      ) : data.length > 0 ? (
        <div className="h-[340px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                innerRadius={68}
                outerRadius={112}
                paddingAngle={3}
                label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
              >
                {data.map((entry) => (
                  <Cell key={entry.name} fill={entry.color} />
                ))}
              </Pie>

              <Tooltip
                formatter={(value) => [`${value} adhérent(s)`, "Total"]}
                contentStyle={{
                  borderRadius: "16px",
                  border: "1px solid #E2E8F0",
                  boxShadow: "0 20px 45px rgba(15, 23, 42, 0.16)",
                }}
              />

              <Legend
                iconType="circle"
                formatter={(value) => (
                  <span className="text-sm text-slate-600 dark:text-slate-300">
                    {value}
                  </span>
                )}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center dark:border-slate-700 dark:bg-slate-950">
          <p className="font-bold text-slate-800 dark:text-slate-100">
            {emptyLabel}
          </p>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            Les graphiques seront alimentés lorsque les données seront
            disponibles.
          </p>
        </div>
      )}
    </SectionCard>
  );
}